import { NetworkId } from '@/types/network'
import { match } from 'ts-pattern'
import { Hex } from 'viem'

export function getPepperAddress(chainId: NetworkId) {
	const address = match(chainId)
		// Spicy
		.with(88882, () => '0x9b4a8Ba57Dce4e0CAf8751e5FB1A3FF54C12A0fE')
		// Staging
		.with(88883, () => '0x2d5C77ce3FaFbcd0deFceD4f5B34D9a9beBeB156')
		// Mainnet
		.with(88888, () => '0x60F397acBCfB8f4e3234C659A3E10867e6fA6b67')
		.exhaustive()

	return address as Hex
}
